import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { UserModel } from 'src/app/models/user.model';
import { DeviceTypeModel, getProductVariantLabel } from 'src/app/models/device-type.model';
import { ApiService } from 'src/app/services/api.service';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';

@Component({
  templateUrl: './device-type.component.html',
  styleUrls: ['./device-type.component.scss']
})
export class DeviceTypeComponent implements OnInit {

  deviceTypes: DeviceTypeModel[] = [];
  loading: boolean = false;
  currentUser?: UserModel;
  isReviewer: boolean = false;
  isAccountManager: boolean = false;

  constructor(
    private api: ApiService,
    private router: Router,
    private breadcrumbService: AppBreadcrumbService
  ) {
    const userStr = localStorage.getItem('currentUser');
    if (userStr) {
      this.currentUser = JSON.parse(userStr);
      this.isReviewer = this.currentUser?.role === 'Reviewer';
      this.isAccountManager = (this.currentUser?.role === 'AccountManager' ||
                               this.currentUser?.role === 'User');
    }
  }

  ngOnInit(): void {
    this.breadcrumbService.setItems([{ label: 'Device Types'}]);
    this.load();
  }

  async load() {
    try {
      this.loading = true;

      const rsp = await this.api.get<{"deviceTypes": DeviceTypeModel[]}>("/device-types");
      this.deviceTypes = rsp.deviceTypes;

      this.deviceTypes.forEach((device: DeviceTypeModel) => {
        device.productVariantDisplay = getProductVariantLabel(device.productVariant);
      });
    } finally {
      this.loading = false;
    }
  }

  //#region table handling
  clear(table: Table) {
    table.clear();
  }

  search(table: Table, event: Event) {
    const element = event.target as HTMLInputElement;
    if (element) {
      table.filterGlobal(element.value, 'contains');
    }
  }
}
